var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.navArr),function({ label, name, to, id }){return _c('el-breadcrumb-item',{key:id,class:{ active: id === _vm.currentName },attrs:{"to":to}},[_c('span',{staticClass:"breadcrumb-label"},[_vm._v(_vm._s(label))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }